import moment from 'moment';
import { CALENDAR_DATE_FORMAT, VALIDITY_STATUS } from '../../helpers/ExpiryRule';

const DESCENDING = 'desc';
const NO_ALERT_RANK = 2;

const ADDON_ALERT_RANK = Object.freeze({
	[VALIDITY_STATUS.EXPIRED]: 0,
	[VALIDITY_STATUS.EXPIRING]: 1,
});

const applyDirection = (difference, order) => {
	return order === DESCENDING ? -difference : difference;
};

// compass hands the final comparator result straight to Array.sort and applies no direction flip, so the
// "rows without a date come last in both directions" rule has to branch on `order` here.
export const compareExpirationDates = (valueA, valueB, order) => {
	if (!valueA && !valueB) {
		return 0;
	}

	if (!valueA) {
		return 1;
	}

	if (!valueB) {
		return -1;
	}

	const difference = moment(valueA, CALENDAR_DATE_FORMAT).valueOf() - moment(valueB, CALENDAR_DATE_FORMAT).valueOf();

	return applyDirection(difference, order);
};

const rankAddonAlert = (alert) => {
	return ADDON_ALERT_RANK[alert] ?? NO_ALERT_RANK;
};

// Ascending puts alerts first (expired, then expiring); the first header click ascends, so one click shows
// the machines that need attention at the top.
export const compareAddonsAlerts = (valueA, valueB, order) => {
	return applyDirection(rankAddonAlert(valueA) - rankAddonAlert(valueB), order);
};
